import { WaPositionTooltip } from "../../Tooltip/WaPositionTooltip/WaPositionTooltip";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { RightAlignCell } from "./WaKeywordPosition";
import styled from "styled-components";
import { chosenSites } from "app/common/services/chosenSites";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import classNames from "classnames";

const RankCell = styled(FlexRow)`
    height: 100%;
    width: 100%;
    align-items: center;
`;

export type tooltipChildType = "icon" | "cell";

interface IWaKeywordPositionCompareProps extends ITableCellProps {
    tooltipChild?: tooltipChildType;
    topSiteColor?: string;
}

export const WaKeywordPositionCompare: FC<IWaKeywordPositionCompareProps> = ({
    row,
    field,
    tooltipChild = "icon",
    topSiteColor,
    className,
}) => {
    const items: { Key: string; Value: number }[] = row[field],
        firstItem = items[0],
        rank = firstItem.Value,
        site = firstItem.Key,
        hasRanks = rank !== -1;

    if (!hasRanks) {
        return (
            <RightAlignCell className={classNames("cell-innerText", className)}>
                <span className="cell-innerText"> - </span>
            </RightAlignCell>
        );
    }
    const color = chosenSites.getSiteColor(site) ?? topSiteColor;

    return tooltipChild === ("cell" as tooltipChildType) ? (
        <WaPositionTooltip data={items}>
            <RankCell className={classNames("cell-innerText wa-keyword-position-compare", className)}>
                <span
                    className="legend-item-circle"
                    style={{ background: color, marginRight: 5 }}
                />
                <span style={{ marginRight: 5 }}>{rank}</span>
            </RankCell>
        </WaPositionTooltip>
    ) : (
        <RightAlignCell className={classNames("cell-innerText", className)}>
            <span
                className="legend-item-circle"
                style={{ background: color, marginRight: 5 }}
            />
            <span style={{ marginRight: 5 }}>{rank}</span>
            <WaPositionTooltip data={items}>
                <span
                    className="sw-icon-show-more"
                    style={{ verticalAlign: "middle" }}
                />
            </WaPositionTooltip>
        </RightAlignCell>
    );
};
WaKeywordPositionCompare.displayName = "WaKeywordPositionCompare";
